<template>
  <v-menu
    top
    offset-y
  >
    <template #activator="{ on, attrs }">
      <v-btn
        icon
        style="position: absolute; top: 0; right: 0"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon :class="iconClass">
          {{ icons.mdiChevronDown }}
        </v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item @click="handleSelectMensagem">
        <v-list-item-title>Responder</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mdiChevronDown } from '@mdi/js'
import { computed } from '@vue/composition-api'

export default {
  emits: ['mensagem-selecionada-para-resposta'],

  props: {
    isMensagemDoAtendente: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    const iconClass = computed(() => (props.isMensagemDoAtendente ? 'white--text' : ''))

    function handleSelectMensagem() {
      emit('mensagem-selecionada-para-resposta')
    }

    return {
      iconClass,
      handleSelectMensagem,
      icons: {
        mdiChevronDown,
      },
    }
  },
}
</script>
